import { ref } from 'vue'
import firebase from '../../firebase'
import { collection, getDocs } from 'firebase/firestore'

const getAllDeviceTypes = () => {
  const allDeviceTypes = ref([])

  const loadDeviceTypes = async () => {
    try {
      const querySnapshot = await getDocs(collection(firebase.db, 'deviceTypes'))
      allDeviceTypes.value = querySnapshot.docs.map(doc => doc.id)
    } catch (error) {
      console.log(error)
    }
  }
  return { allDeviceTypes, loadDeviceTypes }
}
export default getAllDeviceTypes
